import { faEnvelope } from '@fortawesome/pro-regular-svg-icons';

import { CONTACT_US_URL, RESOURCES_URL } from '@constants/constants';

export const HEADER_UTILITY_NAV_ITEMS = [
  {
    label: 'Contact Us',
    url: CONTACT_US_URL,
    icon: faEnvelope,
  },
  {
    label: 'Resources',
    url: RESOURCES_URL,
    newLine: true,
  },
];

export const getHeaderUtilityNavItems = (showResources: boolean) =>
  HEADER_UTILITY_NAV_ITEMS.filter(({ url }) => showResources || url !== RESOURCES_URL);
